
import React from 'react';
import { TableContainer, Box, TableHead, TableBody, TableRow, TableCell, Skeleton, Paper, Table, Typography, Button, IconButton, Grid } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import OrgRow from '../../orgs/list/list';
import UsTiresRow from '../../ustires/list/list';
import RoleRow from '../../roles/list/list';
import UserRow from '../../users/list/list';
import PrivateDBRow from '../../privatedb/list/list';

const classes = {
    orange: {
        color: "#FE8200 !important"
    },
    green: {
        color: "#2e6a2c !important"
    },
    p0: {
        padding:"0px"
    },
    tableHeader: {
        padding: "10px",
        borderBottom: "1px solid #2e6a2c",
        borderTop: "1px solid #2e6a2c"
    },
    normalText: {
        textTransform: "inherit"
    },
    cell: {
        
        padding: "10px 5px 10px 5px"
    }
}

const changeSortField = () => {

}

const changeSortOrder = () => {

}

const CommonTableContainer = (props) => {
    const {tableTitle, sort, order, loadColumn, loadRow, activeList, type, fulfilled, projectId, blockId} = props.value;
    return (
        <TableContainer component={Paper} elevation={0}>
            <Box component={Table} alignItems="center" marginBottom="0!important">
                <TableHead>
                    <TableRow  sx={classes.tableHeader}>
                        {tableTitle.map((title, tIndex)=>
                            <TableCell key={tIndex} sx={classes.cell} >
                                {title.sort?
                                    <Button size="small" onClick={()=>changeSortField(title.sort)} sx={classes.normalText} color="success" >
                                        <Typography variant="h4" align="left" sx={classes.green}>{title.value}</Typography>
                                    </Button>
                                :
                                    <Typography variant="h4" align="left" sx={classes.green}>{title.value}</Typography>
                                }
                                {sort===title.sort?
                                    <IconButton size="small" onClick={()=>changeSortOrder()} sx={classes.p0}>
                                        {order==="desc"?<ArrowDropDownIcon />:<ArrowDropUpIcon />}
                                    </IconButton>
                                :''}
                            </TableCell>
                        )}
                    </TableRow>
                </TableHead>
                {activeList.length===0 && fulfilled==='rejected'?
                    <React.Fragment>
                        <TableBody>
                            <TableRow >
                                <TableCell colSpan={tableTitle.length}>
                                    <Typography variant="body1" align="center" 
                                        sx={{
                                            marginTop: 5,
                                            marginBottom: 5,
                                            fontSize: "12px"
                                        }}
                                    >
                                        
                                        Click "Create" button above to create new record.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </React.Fragment>
                :
                    <React.Fragment>
                        {fulfilled!=='fulfilled'?
                            <TableBody>
                                {loadColumn.map((column,cIndex) => 
                                    <TableRow key={cIndex}>
                                        {loadRow.map((row, rIndex) =>
                                            <TableCell key={rIndex}>
                                                <Skeleton />
                                            </TableCell>
                                        )}
                                    </TableRow>
                                )}
                            </TableBody>
                        :
                            <TableBody>
                                {type==='org'?
                                    <React.Fragment>
                                        {activeList.map((a, index)=>
                                            <OrgRow value={{record:a, index: index}} key={index} />
                                        )}
                                    </React.Fragment>
                                :''}
                                {type==='ustires'?
                                    <React.Fragment>
                                        {activeList.map((a, index)=>
                                            <UsTiresRow value={{record:a, index: index}} key={index} />
                                        )}
                                    </React.Fragment>
                                :''}
                                {type==='role'?
                                    <React.Fragment>
                                        {activeList.map((a, index)=>
                                            <RoleRow value={{record:a, index: index}} key={index} />
                                        )}
                                    </React.Fragment>
                                :''}
                                {type==='user'?
                                    <React.Fragment>
                                        {activeList.map((a, index)=>
                                            <UserRow value={{record:a, index: index}} key={index} />
                                        )}
                                    </React.Fragment>
                                :''}
                                {type==='privateDB'?
                                    <React.Fragment>
                                        {activeList.map((a, index)=>
                                        
                                            <PrivateDBRow value={{record:a, index: index}} key={index} />
                                        )}
                                    </React.Fragment>
                                :''}
                                
                            </TableBody>
                        }
                    </React.Fragment>
                }
            </Box>
        </TableContainer>
    )
}

export default CommonTableContainer;